define('plugin/telegram-notifications/model/TelegramNotificationsModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * PWA device Model
     *
     * @class PwaDeviceModel
     */
    return BaseModel.extend({

        url: '/ext/telegram-notifications/info/',

        defaults: {
            'datetime': null,
            'hash': null,
            'token': null,
            'type': null
        },

        initialize: function () {

            this.on('sync', this._onModelSync);

            BaseModel.prototype.initialize.call(this);
        },

        _onModelSync: function () {

        }
    });

});
